<template>
  <footer class="bg-surface-deep py-16 text-[#DEE2E6] [--color-focus-ring:#FFFFFF]">
    <div class="gob-container">
      <div class="mb-10 grid gap-10 md:grid-cols-[1fr_2fr]">
        <div class="flex flex-col gap-3">
          <div class="flex items-center gap-2 text-3xl font-bold text-white">
            <router-link to="/" class="flex items-center gap-2 font-bold text-white no-underline">
              <img 
                src="@/assets/dubs-logo-white-02.svg" 
                alt="Gob 24/7" 
                class="logo-imagen"
              />
            </router-link>
          </div>
          <p class="max-w-xs mt-4 text-[#DEE2E6]">Más que tecnología, un aliado para dar un salto a ciudades inteligentes.</p>
        </div>

        <div class="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          <div>
            <h4 class="gob-footer-heading">Navegación</h4>
            <div class="flex flex-col gap-2">
              <router-link class="gob-footer-link" to="/">Inicio</router-link>
              <router-link class="gob-footer-link" to="/problema">El Reto Territorial</router-link>
              <router-link class="gob-footer-link" to="/trayectoria">Trayectoria</router-link>
              <router-link class="gob-footer-link" to="/como-empezar">¿Cómo empezar?</router-link>
              <router-link class="gob-footer-link" to="/contacto">Contacto</router-link>
            </div>
          </div>

          <div>
            <h4 class="gob-footer-heading">Ecosistema Gob</h4>
            <div class="flex flex-col gap-2">
              <router-link
                v-for="solucion in soluciones"
                :key="solucion.id"
                class="gob-footer-link"
                :to="solucion.ruta"
              >
                {{ solucion.nombre }}
              </router-link>
            </div>
          </div>

          <div>
            <h4 class="gob-footer-heading">Contacto</h4>
            <div class="flex flex-col gap-2">
              <a class="gob-footer-link" href="mailto:info@gob247.com">hola@gob247.com</a>
              <a class="gob-footer-link" href="tel:+573013634264">+57 3013634264</a>
              <a class="gob-footer-link" href="tel:+573163847410">+57 3163847410</a>
            </div>
          </div>
        </div>
      </div>

      <div class="border-t border-white/10 pt-5 text-center text-sm text-[#ADB5BD]">
        <p>&copy; {{ year }} Gob 24/7. Todos los derechos reservados.</p>
        <p>Diseñado y desarrollado por <a href="https://www.qubilo.com" target="_blank" class="text-white mt-2 inline-block">Qubilo</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
import { SOLUCIONES } from '@/data/soluciones'

/**
 * SiteFooter
 * Pie de página global de la web.
 * Se encarga de mostrar navegación secundaria, contacto institucional
 * y el año actual para mantener el sitio actualizado sin intervención manual.
 */
export default {
  name: 'SiteFooter',
  data() {
    return { soluciones: SOLUCIONES }
  },
  computed: {
    /**
     * year
     * Devuelve el año vigente para mostrarlo en el footer.
     */
    year() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
/**
 * .logo-imagen
 * Limita el logo del pie a la escala del header; sin esta regla el PNG
 * (1800 × 579 px) se pintaba a casi 400 px de ancho.
 */
.logo-imagen {
  display: block;
  width: auto;
  height: 82px;
}

@media (max-width: 768px) {
  .logo-imagen {
    height: 72px;
  }
}
</style>
